import {FormsStore} from './FormsStore';
import {Column} from '../serializers/column';

export type ColumnsMap = Map<string, Column>;

export class FormTable {
    store: FormsStore;
    paintedColumnsMap: ColumnsMap;
    tableViewColumnsmap: ColumnsMap;
    paintedZoomField: string;
    tableViewZoomField: string;

    constructor(store, data) {
        this.store = store;
        this.updateFormColumns(data.columnsMap, data.zoomField, data.isPainted);
    }

    updateFormColumns(columns, zoomField, isPainted) {
        if (isPainted) {
            this.paintedColumnsMap = columns;
            this.paintedZoomField = zoomField;
        } else {
            this.tableViewColumnsmap = columns;
            this.tableViewZoomField = zoomField;
        }
    }
}
